export const getAppRoot = () => document.getElementById('root');
